<mat-dialog-content id="dialog-content">

  <!-- Name -->
  <div>
    <mat-form-field>
      <mat-label>{{'Prénom' | translate}}</mat-label>
      <input matInput [(ngModel)]="dialogData.Name" />
    </mat-form-field>
  </div>

  <!-- Last name -->
  <div>
    <mat-form-field>
      <mat-label>{{'Nom' | translate}}</mat-label>
      <input matInput [(ngModel)]="dialogData.LastName" />
    </mat-form-field>
  </div>

  <!-- Phone -->
  <div>
    <mat-form-field>
      <mat-label>{{'Téléphone' | translate}}</mat-label>
      <input matInput type="tel" [(ngModel)]="dialogData.Phone" />
      <mat-icon matSuffix>phone</mat-icon>
    </mat-form-field>
  </div>

  <!-- Email -->
  <div>
    <mat-form-field>
      <mat-label>{{'Email' | translate}}</mat-label>
      <input matInput type="email" [(ngModel)]="dialogData.Email" />
      <mat-icon matSuffix>mail</mat-icon>
    </mat-form-field>
  </div>

</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-raised-button tabindex="4" (click)="onBtnClick(true)">{{'Enregistrer' | translate}}</button>
  <button mat-raised-button tabindex="4" (click)="onBtnClick(false)">{{'Fermer' | translate}}</button>
</div>
